module.exports = __webpack_public_path__ + "static/media/trash-hover.1bc10109.svg";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/trash-hover.svg
// module id = 73
// module chunks = 0